import { api } from '@/lib/api'
import type {
  AIRecommendation,
  BudgetActiveResponse,
  BudgetAnalysisResponse,
  BudgetItem,
  CategoryTransactionsResponse,
  DetectedRecurringCandidate,
  RecurringTransaction,
  UpcomingPaymentsResponse,
} from './types'

export const budgetApi = {
  active: (month: number, year: number) =>
    api.get<BudgetActiveResponse>('/api/budget/active', { query: { month, year } }),
  analysis: (month: number, year: number) =>
    api.get<BudgetAnalysisResponse>('/api/budget/analysis', { query: { month, year } }),
  aiRecommendations: (month: number, year: number) =>
    api.post<{ recommendations: AIRecommendation[]; cached?: boolean }>('/api/budget/ai-recommendations', {
      month,
      year,
    }),
  upcomingPayments: (days = 14) =>
    api.get<UpcomingPaymentsResponse>('/api/budget/upcoming-payments', { query: { days } }),
  categories: () => api.get<{ categories: string[] }>('/api/budget/categories'),
  categoryTransactions: (category: string, month: number, year: number) =>
    api.get<CategoryTransactionsResponse>(
      `/api/budget/transactions/${encodeURIComponent(category)}`,
      { query: { month, year } },
    ),
  recurring: () =>
    api.get<{ recurring_transactions: RecurringTransaction[] }>('/api/budget/recurring'),
  updateTotal: (budgetId: number, totalAmount: number) =>
    api.put(`/api/budget/${budgetId}/total`, { total_amount: totalAmount }),
  bulkSaveItems: (budgetId: number, items: Array<Partial<BudgetItem> & { budgeted_amount: number }>) =>
    api.post(`/api/budget/${budgetId}/items/bulk`, { items }),
  reset: (budgetId: number) => api.post(`/api/budget/${budgetId}/reset`),
  deleteItem: (itemId: number) => api.del(`/api/budget/items/${itemId}`),
  addItem: (budgetId: number, item: Partial<BudgetItem>) =>
    api.post(`/api/budget/${budgetId}/items`, item),
  generateAlerts: (month: number, year: number) =>
    api.post('/api/budget/generate-alerts', { month, year }),
  addRecurring: (body: Partial<RecurringTransaction>) =>
    api.post<{ recurring_transaction: RecurringTransaction }>('/api/budget/recurring', body),
  deleteRecurring: (id: number) => api.del(`/api/budget/recurring/${id}`),
  detectRecurring: () =>
    api.post<{ candidates: DetectedRecurringCandidate[] }>('/api/budget/detect-recurring'),
  recurringInsights: (recurringItems: RecurringTransaction[]) =>
    api.post<{ insights: string[]; cached?: boolean }>('/api/budget/recurring-insights', {
      recurring_transactions: recurringItems,
    }),
}
